import React from 'react'

import { Row, Col, Container, Table, Form } from 'react-bootstrap'
import { Portfolio, Carousel } from './../../components'
import { getConstructions } from './../../core/api/constructions-provider'
import { StyledOutlinedButton, StyledNavigationIcon, StyledActionsContainer, StyledDocument, StyledDividerLine, StyledDivider, StyledTitle, StyledCarouselItem, StyledCarouselWrapper,StyledTrHead, StyledThHead, StyledTr, StyledTd, StyledLogo, StyledSelect, StyledLogoo } from './styled'
import { Page } from 'react-pdf';
import Arrow from './../../common/images/arrow.svg'


const Obras = () => {

    const [constructionsData, setConstructionsData] = React.useState()
    const [constructions, setConstructions] = React.useState()
    
    const [numPages, setNumPages] = React.useState(null);
    const [pageNumber, setPageNumber] = React.useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    React.useEffect(() => {
        getConstructions().then(res => setConstructionsData(res.data))
    }, [])

    React.useEffect(() => {
        if(constructionsData) {
            const constructions = constructionsData.customers.map((el) => {
                return el?.obras
                ? { constructions : el.obras, title: el.title, id: el.ID, image: el.image.url}
                : false
            }).filter(el => el !== false)
            setConstructions(constructions)
        }
    }, [constructionsData])

    return (
        <>
            {
                constructionsData && (
                    <>
                        <Carousel slides={constructionsData.slides}/>
                        <Container fluid>
                        
                            <Row className='mt-5'>
                                <Col xs={12} id='recem-entregues' className='d-flex justify-content-center align-items-center'>
                                    <StyledDivider>
                                        <StyledDividerLine/>
                                        <StyledTitle>Obras recém-entregues</StyledTitle>
                                    </StyledDivider>
                                </Col>
                            </Row>
                            <Row className='my-5'>
                                <Col xs={12} md={{span: 10, offset: 1}}>
                                    {
                                        constructionsData.portfolio.map((portfolio, index) => (
                                            <Row className='py-5'>
                                                <Col xs={12} className='px-0'>
                                                    <Portfolio portfolio={portfolio} index={index}/>
                                                </Col>
                                            </Row>
                                        ))
                                    }
                                </Col>
                            </Row>

                            <Row className='mt-5'>
                                <Col xs={12} id='execucao' className='d-flex justify-content-center align-items-center'>
                                    <StyledDivider>
                                        <StyledDividerLine/>
                                        <StyledTitle>OBRAS EM EXECUÇÃO</StyledTitle>
                                    </StyledDivider>
                                </Col>
                            </Row>

                            <Row>
                                <Col
                                    md={{
                                        span: 10,
                                        offset: 1
                                    }}
                                    xs={12}
                                >
                                    {
                                        constructionsData?.customers?.filter((customers) => customers.obras !== null && customers.obras !== false)
                                        .sort((a,b) => a.title.localeCompare(b.title))
                                        .map((item) => {
                                            console.log('ITEM:>> ', item)
                                            return(
                                            <Row className='my-5'>
                                                <Col className='my-5 my-md-0' xs={{span:6, offset: 3}} md={{span: 3, offset: 0}}>
                                                    <Row>
                                                        <Col xs={12} md={10}>
                                                            <StyledLogoo style={{width: '100%', height: 'auto'}} src={item.image.url} alt={item.image.alt}/>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {
                                                    item.obras && Array.isArray(item.obras) && (
                                                        item?.obras.map((element, index) => (
                                                            <Col
                                                                md={{
                                                                    span: 4,
                                                                    offset: index > 0 && index % 2 === 0 ? 3 : 0
                                                                }}
                                                                xs={12}
                                                            >
                                                                <img style={{width: '100%', height: 'auto'}} src={element.image.url} alt={element.image.alt}/>
                                                                <div className='mt-2' dangerouslySetInnerHTML={{__html: element.description}}>
                                                                </div>
                                                            </Col>
                                                        ))
                                                    )
                                                }
                                            </Row>
                                        )})
                                    }
                                </Col>
                            </Row>

                            <Row className='mt-5 mb-3'>
                                <Col xs={12} id='portfolio' className='d-flex justify-content-center align-items-center'>
                                    <StyledDivider>
                                        <StyledDividerLine/>
                                        <StyledTitle>Portfólio</StyledTitle>
                                    </StyledDivider>
                                </Col>
                            </Row>

                            {
                                constructionsData?.portfolioPDF && (
                                    <>
                                    <Row className='mb-5'>
                                        <Col className='d-flex justify-content-center flex-column align-items-center'>
                                            <StyledDocument
                                                file={constructionsData?.portfolioPDF.url}
                                                onLoadSuccess={onDocumentLoadSuccess}
                                                >
                                                <Page
                                                    renderInteractiveForms
                                                    renderAnnotationLayer
                                                    renderTextLayer
                                                    pageNumber={pageNumber}
                                                    width={500}
                                                    scale={1}
                                                    />
                                                <StyledActionsContainer>
                                                    <StyledNavigationIcon
                                                        onClick={() => {
                                                            if(pageNumber <= numPages && pageNumber !== 1) {
                                                                setPageNumber((prev) => {
                                                                    return prev - 1
                                                                })
                                                            }
                                                        }}
                                                        className='left'
                                                        src={Arrow} alt=''
                                                    />
                                                    <p>Página {pageNumber} de {numPages}</p>
                                                    <StyledNavigationIcon
                                                        onClick={() => {
                                                            if(pageNumber >= 1 && pageNumber !== numPages) {
                                                                setPageNumber((prev) => {
                                                                    return prev + 1
                                                                })
                                                            }
                                                        }}
                                                        src={Arrow}
                                                        alt=''
                                                    />
                                                </StyledActionsContainer>
                                            </StyledDocument>
                                        </Col>
                                    </Row>
                                    <Row className='mb-5'>
                                        <Col className='d-flex justify-content-center align-items-center flex-row'>
                                            <StyledOutlinedButton href={constructionsData?.portfolioPDF.url} download="PortfolioFR.pdf" target="_blank">
                                                Download
                                            </StyledOutlinedButton>
                                        </Col>
                                    </Row>
                                    </>
                                )
                            }
                        </Container>
                    </>
                )
            }
        </>
    )
}

export default Obras